.skin-modern {
  &.zeudy-player__wrapper {
    button.plyr__control.plyr__control--overlaid {
      border-radius: 2px;
      padding: 3% 5%;
      max-width: 135px;
      max-height: 90px;
      box-sizing: content-box;
      position: absolute !important;
      top: 50% !important;
      opacity: 100%;
      svg {
        height: 31px;
        width: 37px;
      }
      &:hover,
      &:focus {
        opacity: 0.8;
        background: var(--plyr-color-main);
      }
    }

    // full captions
    &.caption-style-full .plyr:not(.plyr--hide-controls):not(.is-muted-overlay) .plyr__controls:not(:empty) ~ .plyr__captions {
      transform: translateY(calc(var(--plyr-control-spacing, 9px) * -4));
    }

    // color background
    .plyr--video .plyr__controls {
      padding: 0px;
      &::before {
        content: '';
        background: var(--plyr-color-main);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.75;
      }
    }

    // adding hover state
    .plyr__controls__item {
      z-index: 1;
      &.plyr__control:not(.zeudy-player-progress__marker):not([role*='menuitem']):not(.plyr__control--back) {
        height: 36px;
        border-radius: 0px;
        &:focus {
          background-color: transparent;
          color: white;
        }
      }
      &.zeudy-player-progress__marker {
        z-index: 2;
      }
      &.plyr__menu {
        height: 36px;
      }
    }

    // completed range
    .plyr--full-ui.plyr--video input[type='range']::-webkit-slider-runnable-track {
      height: 2px;
      color: white;
    }

    // will complete range
    .zeudy-player__wrapper .plyr--full-ui.plyr--video input[type='range']::-webkit-slider-runnable-track {
      height: 2px;
    }

    // for buffer
    .plyr--video .plyr__progress__buffer {
      height: 2px;
      top: 11px;
    }

    .plyr__progress {
      input[type='range'] {
        cursor: pointer;
      }
    }

    // for range button
    .plyr--full-ui input[type='range']::-webkit-slider-thumb {
      top: 1px;
      height: var(--plyr-range-thumb-height, 8px);
      width: var(--plyr-range-thumb-height, 8px);
      box-shadow: 0px 0px 5px white;
      &:hover {
        transform: scale(1.5);
      }
    }

    // margin control
    .plyr__controls .plyr__controls__item {
      margin: 0px;
    }

    // volume width
    .plyr__volume {
      width: auto;
      input[type='range'] {
        width: 55px;
      }
    }

    // for soun range cursor
    .plyr__volume input[type='range'] {
      cursor: pointer;
    }

    // muted autoplay button size
    .zeudy-player__muted-overlay {
      .plyr__control {
        &.plyr__control--overlaid {
          border-radius: 2px;
          svg {
            height: 40px;
            width: 50px;
          }
        }
      }
    }

    .plyr__controls .plyr__controls__item[data-plyr='rewind'] svg,
    .plyr__controls .plyr__controls__item[data-plyr='fast-forward'] svg,
    .plyr__controls .plyr__controls__item[data-plyr='fullscreen'] svg {
      width: 22px;
      height: 22px;
    }

    @media screen and (max-width: 480px) {
      .plyr__control--overlaid {
        svg {
          height: 18px;
          width: 16px;
        }
      }
    }
  }
}
